import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pg-masters-of-science-computer-science',
  templateUrl: './pg-masters-of-science-computer-science.component.html',
  styleUrls: ['./pg-masters-of-science-computer-science.component.scss']
})
export class PgMastersOfScienceComputerScienceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
